module.exports = __webpack_public_path__ + "static/media/t-2-q-10-3.9c463671.png";